import { Box, Typography } from '@mui/material';
import { Checkbox } from '@mui/material';
import { FilterValue } from '@/generated/contentfulTypes';
import { PrimaryColors } from '@/common/theme/constants';

export interface FilterCheckboxProps {
  checked: boolean;
  filterValue: FilterValue;
  onFilterSelect: (filter: FilterValue) => void;
}

export default function FilterCheckbox({
  checked,
  filterValue,
  onFilterSelect,
}: FilterCheckboxProps) {
  return (
    <Box>
      <Checkbox
        checked={checked}
        onChange={() => onFilterSelect(filterValue)}
        sx={{
          color: PrimaryColors.black,
          padding: '4px',
        }}
      />
      <Typography variant="body1" component="span">
        {filterValue.filterValueTitle?.value}
      </Typography>
    </Box>
  );
}
